const comparisonTableDataUS = {
  header: {
    icons: ['ADTLogo'],
    titles: ['ADT'],
    competitors: ['ADT']
  },
  body: [
    {
      values: [true, true],
      feature: '24/7 professional monitoring',
      infoIcon: {
        title: '24/7 professional monitoring',
        description: [
          'Break-ins, fires, water damage, even extreme temperatures — whatever the danger, professional monitoring from SimpliSafe® will protect your home. You’ll have the peace of mind of knowing that trained security experts are keeping your home and family safe.'
        ],
        modalLocation: 'professional-monitoring'
      }
    },
    {
      values: [true, true],
      feature: 'Mobile app control & smart home integration',
      infoIcon: {
        title: 'Mobile app control & smart home integration',
        description: [
          'The SimpliSafe® App is available for iOS and Android devices and offers full control over your system. Arm your system with Alexa, Google Assistant, and Apple Watch.'
        ],
        modalLocation: 'home-integration'
      }
    },
    {
      values: [true, true],
      feature:
        'Up to 24-hour battery backup, Wi-Fi, and cellular connectionSUP(1)',
      infoIcon: {
        title: 'Up to 24-hour battery backup, Wi-Fi, and cellular connection',
        description: [
          'The Base Station connects to Wi-Fi out of the box, and with an active professional monitoring plan will connect to the cellular network as a backup. Battery backup provides up to 24 hours of continued performance during a power outage.'
        ],
        modalLocation: 'battery-backup'
      }
    },
    {
      values: [true, false],
      feature:
        'Agents can help prevent crime before it happens using the outdoor cameraSUP(2)',
      infoIcon: {
        title:
          'Agents can help prevent crime before it happens using the outdoor camera',
        description: [
          'With a Pro or Pro Plus monitoring plan, SimpliSafe® security agents can now intervene when there’s a potential threat outside your home. All you need is the Outdoor Camera (Series 2).',
          'While your system is armed during plan hours, agents can use the live video feed and 2-way audio to see and speak to trespassers, or activate the camera’s loud, built-in siren and bright spotlight to drive them away — deterring crimes in progress.',
          'SimpliSafe® Active Guard Outdoor Protection is for residential use only and is not available in Puerto Rico.'
        ],
        modalLocation: 'prevent-crime'
      }
    },
    {
      values: [true, false],
      feature:
        'Agents can use the indoor camera to help stop crime in real timeSUP(3)',
      infoIcon: {
        title:
          'Agents can use the indoor camera to help stop crime in real time',
        description: [
          "Agents can use the Smart Alarm indoor camera to see, speak to and deter intruders in real time during an alarm. Agents can only access your camera's microphone and video feed during an active alarm."
        ],
        modalLocation: 'help-stop-crime'
      }
    },
    {
      values: [true, false],
      feature: 'Integrated privacy shutter on all indoor cameras'
    },
    {
      values: [true, false],
      feature:
        'Lifetime warranty and 10% discount on hardware included for subscribersSUP(4)'
    },
    {
      values: [true, false],
      feature:
        'No long-term contracts or hidden fees for all customers. Cancel anytimeSUP(5)'
    },
    {
      values: [true, false],
      feature: 'Customers more likely to recommendSUP(6)'
    }
  ],
  footer: [
    'SUP(1)Cellular backup available with professional monitoring plans.',
    'SUP(2)Requires an Outdoor Camera (Series 2) and a monitoring plan with SimpliSafe® Active Guard️ Outdoor Protection.',
    'SUP(3)Requires a Smart Alarm Indoor Camera with select professional monitoring plans.',
    'SUP(4)With select professional monitoring plans.',
    'SUP(5)Contract required for ADT Pro Installed.',
    'SUP(6)December 2024 Competitor NPS Study'
  ]
}

const comparisonTableDataUK = {
  body: [
    {
      values: [true, true],
      feature: 'Whole home protection',
      infoIcon: {
        title: 'Whole home protection',
        description: [
          'SimpliSafe® offers sensors and professional monitoring to protect your home inside and out against break-ins, fires & smoke, water & floods, and more.'
        ],
        modalLocation: 'home-protection'
      }
    },
    {
      values: [true, true],
      feature: 'Mobile app control',
      infoIcon: {
        title: 'Mobile app control',
        description: [
          'The SimpliSafe® App is available for iOS and Android devices and offers full control over your system. Arm your system with Alexa, Google Assistant, and Apple Watch.'
        ],
        modalLocation: 'home-integration'
      }
    },
    {
      values: [true, true],
      feature: 'Smart home integration*',
      infoIcon: {
        title: 'Smart home integration',
        description: [
          'The SimpliSafe® App is available for iOS and Android devices and offers full control over your system. Arm your system with Alexa, Google Assistant, and Apple Watch.'
        ],
        modalLocation: 'home-integration'
      }
    },
    {
      values: [true, false],
      feature: '24/7 professional monitoring for less than 66p/day'
    },
    {
      values: [true, false],
      feature: 'Pro Premium Monitoring for police and private guard response',
      infoIcon: {
        title: 'Police response',
        description: [
          'Advanced technology enables our professional monitoring centre to visually verify threats, so they can request police dispatch when you subscribe to the Pro Premium Monitoring plan.'
        ],
        modalLocation: 'police-response'
      }
    },
    {
      values: [true, false],
      feature:
        'Agents automatically verify alarms, access footage & contact you*'
    },
    {
      values: [true, false],
      feature: 'Up to 24-hour battery backup, Wi-Fi and cellular connection',
      infoIcon: {
        title: 'Up to 24-hour battery backup, Wi-Fi and cellular connection',
        description: [
          'The Base Station connects to Wi-Fi out of the box, and with an active monitoring plan will connect to the cellular network as a backup. Battery backup provides up to 24 hours of continued performance during a power outage.'
        ],
        modalLocation: 'battery-backup'
      }
    },
    {
      values: [true, false],
      feature: 'Integrated privacy shutter on all indoor cameras'
    },
    {
      values: [true, false],
      feature: 'Lifetime warranty and 20% discount on hardware for subscribers*'
    },
    {
      values: [true, false],
      feature: 'No contracts or hidden fees. Cancel anytime.'
    }
  ],
  footer: ['* Requires Pro Premium️ plan.'],
  header: {
    titles: ['Traditional Home Security'],
    competitors: ['Traditional Home Security']
  }
}

export const comparisonTableData = {
  'en-US': comparisonTableDataUS,
  'en-GB': comparisonTableDataUK
}
